
  export default {
    props: {
      blok: {
        type: Object,
        default: () => {}
      }
    },
    computed: {
      city() {
        return this.blok.city_name
      }
    }
  }
